module.exports = __webpack_public_path__ + "static/myles-earn-free-roadside-assistance-b2d4b64f6b32c698d124a763cfaf2ec1.jpg";